import { apiRoot, ResponseStatus } from "../app/store/store";
import { Guess, GuessID } from "../types/Guess.type";
import { RunID } from "../types/Run.type";
import { ShowID } from "../types/Show.type";
import { SongID } from "../types/Song.type";
import { User, UserID } from "../types/User.type";

export const getGuessesForShow = (showId: ShowID): Promise<Guess[] | ResponseStatus.UnknownError> => {
    return new Promise(async (resolve) => {
        const response = await fetch(`${apiRoot}/guesses?showId=${showId}`);
        if (response.status === 200) {
            const data = await response.json();
            if (data.hasOwnProperty('guesses')) {
                resolve(data.guesses as Guess[]);
            } else {
                resolve(ResponseStatus.UnknownError);
            }
        } else {
            resolve(ResponseStatus.UnknownError);
        }
    });
}

export const getGuessesForRun = (runId: RunID): Promise<Guess[] | ResponseStatus.UnknownError> => {
    return new Promise(async (resolve) => {
        const response = await fetch(`${apiRoot}/guesses?runId=${runId}`);
        if (response.status === 200) {
            const data = await response.json();
            if (data.hasOwnProperty('guesses')) {
                resolve(data.guesses as Guess[]);
            } else {
                resolve(ResponseStatus.UnknownError);
            }
        } else {
            resolve(ResponseStatus.UnknownError);
        }
    });
}

export const getGuessesForUserForRun = (userId: UserID, runId: RunID): Promise<Guess[] | ResponseStatus.UnknownError> => {
    return new Promise(async (resolve) => {
        const response = await fetch(`${apiRoot}/guesses?runId=${runId}&userId=${userId}`);
        if (response.status === 200) {
            const data = await response.json();
            if (data.hasOwnProperty('guesses')) {
                resolve(data.guesses as Guess[]);
            } else {
                resolve(ResponseStatus.UnknownError);
            }
        } else {
            resolve(ResponseStatus.UnknownError);
        }
    });
}

export const getGuessesForUserForShow = (userId: UserID, showId: ShowID): Promise<Guess[] | ResponseStatus.UnknownError> => {
    return new Promise(async (resolve) => {
        const response = await fetch(`${apiRoot}/guesses?showId=${showId}&userId=${userId}`);
        if (response.status === 200) {
            const data = await response.json();
            if (data.hasOwnProperty('guesses')) {
                resolve(data.guesses as Guess[]);
            } else {
                resolve(ResponseStatus.UnknownError);
            }
        } else {
            resolve(ResponseStatus.UnknownError);
        }
    });
}

export const getGuessesForUser = (userId: UserID): Promise<Guess[] | ResponseStatus.UnknownError> => {
    return new Promise(async (resolve) => {
        const response = await fetch(`${apiRoot}/guesses?userId=${userId}`);
        if (response.status === 200) {
            const data = await response.json();
            if (data.hasOwnProperty('guesses')) {
                resolve(data.guesses as Guess[]);
            } else {
                resolve(ResponseStatus.UnknownError);
            }
        } else {
            resolve(ResponseStatus.UnknownError);
        }
    });
}

export const createGuess = (userId: UserID, runId: RunID, showId: ShowID, songId: SongID, songName: string, encore: boolean): Promise<Guess | ResponseStatus.Conflict | ResponseStatus.UnknownError> => {
    return new Promise(async (resolve) => {
        const response = await fetch(`${apiRoot}/guesses`, { 
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ userId, runId, showId, songId, songName, encore })
        });
        if (response.status === 200) {
            const data = await response.json();
            if (data.hasOwnProperty('guess')) {
                resolve(data.guess as Guess);
            } else {
                resolve(ResponseStatus.UnknownError);
            }
        } else if (response.status === 409) {
            resolve(ResponseStatus.Conflict);
        } else {
            resolve(ResponseStatus.UnknownError);
        }
    })
}

export const deleteGuess = (guessId: GuessID): Promise<ResponseStatus.Success | ResponseStatus.UnknownError> => {
    return new Promise(async (resolve) => {
        const response = await fetch(`${apiRoot}/guesses/${guessId}`, { method: 'DELETE' });
        if (response.status === 200) {
            resolve(ResponseStatus.Success);
        } else {
            resolve(ResponseStatus.UnknownError);
        }
    })
}

export const scoreGuessesForShow = (showId: GuessID, songs: {id: string, encore: boolean}[]): Promise<ResponseStatus.Success | ResponseStatus.UnknownError> => {
    return new Promise(async (resolve) => {
        const response = await fetch(`${apiRoot}/guesses/score/${showId}`, { 
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify({ songs }) 
        });
        if (response.status === 200) {
            resolve(ResponseStatus.Success);
        } else {
            resolve(ResponseStatus.UnknownError);
        }
    })
}
